import React, { useEffect, useState } from 'react';
import { useAuth } from '../context/AuthContext';
import { Link, useNavigate } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const Register = () => {
	const [user, setUser] = useState({
		email: '',
		password: '',
	});

  const [error, setError] = useState()

	const { signup } = useAuth()
  const navigate = useNavigate()

  useEffect(() =>{
    error && toast.error(error, {
      position: "bottom-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      });
  },[error])

	const handleChange = (evt) => {
		const { target } = evt;
		setUser((prevUser) => {
			return {
				...prevUser,
				[target.name]: target.value,
			};
		});
	};

	const handleSubmit = async (evt) => {
		evt.preventDefault();
    setError('')
    try {
      await signup(user.email, user.password);
      navigate('/')
    } catch (err) {
      if(err.code === 'auth/internal-error'){
        setError('Correo Invalido')
      } else if (err.code === 'auth/weak-password'){
        setError('La contraseña debe ser de almenos 6 caracteres')
      } else{
        setError(err.message)
      }
    }
	};

	return (
		<div className='flex items-center justify-center min-h-screen '>
      <div className='w-full max-w-xs m-auto'>
        <h1 className='mb-5 text-4xl font-semibold text-center'>TecnoClothes</h1>
            <ToastContainer
              position="bottom-right"
              autoClose={5000}
              hideProgressBar={false}
              newestOnTop={false}
              closeOnClick
              rtl={false}
              pauseOnFocusLoss
              draggable
              pauseOnHover
              />
      
            <form onSubmit={handleSubmit} className='px-4 py-6 space-y-2 bg-white rounded-md border- '>
        <div className='flex flex-col mb-5 space-y-2'>
              <label htmlFor="email" className='font-bold '>Email</label>
              <input
                type="email"
                name="email"
                placeholder="example@company.com"
                onChange={handleChange}
                className='p-2 border rounded border-slate-500'
              />
            </div>
        <div className='flex flex-col mb-5 space-y-2'>
              <label htmlFor="password" className='font-bold '>Contraseña</label>
              <input
                type="password"
                name="password"
                id="password"
                placeholder='******'
                onChange={handleChange}
                className='p-2 border rounded border-slate-500'
              />
            </div>
        <button className='btn-primary'>Registrar</button>
      </form>
      
      <p className='flex justify-between mt-5 font-bold'>Ya tienes una cuenta? <Link to='/login'> Ingresar</Link></p>
      
      </div>
    </div>
	);
};

export default Register;
